import React from "react";

const DeleteIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_12259_9545)">
<path d="M10.8369 3.87141V3.31141C10.8369 2.52734 10.8369 2.1353 10.6862 1.83582C10.5536 1.5724 10.3421 1.35822 10.0819 1.224C9.7861 1.07141 9.39891 1.07141 8.62451 1.07141H7.51834C6.74395 1.07141 6.35675 1.07141 6.06097 1.224C5.8008 1.35822 5.58927 1.5724 5.4567 1.83582C5.306 2.1353 5.306 2.52734 5.306 3.31141V3.87141M6.68871 7.72141V11.2214M9.45414 7.72141V11.2214M1.84921 3.87141H14.2936M12.9109 3.87141V11.7114C12.9109 12.8875 12.9109 13.4756 12.6849 13.9248C12.486 14.3199 12.1687 14.6412 11.7785 14.8425C11.3348 15.0714 10.754 15.0714 9.59241 15.0714H6.55044C5.38885 15.0714 4.80805 15.0714 4.36439 14.8425C3.97412 14.6412 3.65683 14.3199 3.45798 13.9248C3.23192 13.4756 3.23192 12.8875 3.23192 11.7114V3.87141" stroke="#BFBFBF" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_12259_9545">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>

  );
};

export default DeleteIcon;